const apiBaseUrl =
    window.location.protocol + "//" + window.location.host + "/o/services/mups";

export default apiBaseUrl;



// WEBPACK FOOTER //
// ./util/apiBaseUrl.js